import React, { useReducer } from 'react';
import './style.scss';
import Player from '../Player';
import { Layers } from '../Layers';
import { StickerPicker } from '../StickerPicker';
import { PrimaryButton, SecondaryButton } from '../commons/Button';
import { VideoPlayer } from '../VideoPlayer/VideoPlayer';

function uuid() {
  var dt = new Date().getTime();
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (dt + Math.random() * 16) % 16 | 0;
    dt = Math.floor(dt / 16);
    return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
}

function reducer(state, action) {
  switch (action.type) {
    case 'UPDATE_ELEMENT':
      return {
        ...state,
        config: {
          ...state.config,
          elements: state.config.elements.map((element) => (element.id === action.payload.id ? { ...element, ...action.payload } : element)),
        },
      };
    case 'DELETE_ELEMENT':
      return {
        ...state,
        config: {
          ...state.config,
          elements: state.config.elements.reduce((acc, element) => (element.id === action.payload.id ? acc : [...acc, element]), []),
        },
      };
    case 'ADD_ELEMENT':
      return {
        ...state,
        config: {
          ...state.config,
          elements: [
            ...state.config.elements,
            {
              name: `New Layer ${state.config.elements.length}`,
              id: uuid(),
              at: state.currentTime,
              position: { x: 0.4, y: 0.4 },
              rotate: 0,
              animate: {
                in: 'bounceIn',
                out: 'fadeOut',
              },
              duration: 2,
              size: {
                height: 0.3,
                width: 0.3,
              },
              ...action.payload,
            },
          ],
        },
      };
    case 'UPDATE_TOTOAL_DURATION':
      return { ...state, totalDuration: action.payload };
    case 'UPDATE_CURRENT_TIME':
      return { ...state, currentTime: action.payload };
    default:
      throw new Error();
  }
}

export const Editor = ({ src: suppliedSrc, config: suppliedConfig, onSave, id }) => {
  const [state, dispatch] = useReducer(reducer, {
    config: { ...suppliedConfig },
    src: suppliedSrc,
    currentTime: 0,
  });
  const { config, src, currentTime, totalDuration } = state;

  const onUpdateTotalDuration = ({ totalDuration }) => {
    dispatch({
      type: 'UPDATE_TOTOAL_DURATION',
      payload: totalDuration,
    });
  };

  const onUpdateCurrentTime = ({ currentTime }) => {
    dispatch({
      type: 'UPDATE_CURRENT_TIME',
      payload: currentTime,
    });
  };

  const onAddElement = (newElement) => {
    dispatch({
      type: 'ADD_ELEMENT',
      payload: newElement,
    });
  };

  const onUpdateElement = (updatedElement) => {
    dispatch({
      type: 'UPDATE_ELEMENT',
      payload: updatedElement,
    });
  };

  const onDeleteElement = (elementToDelete) => {
    dispatch({
      type: 'DELETE_ELEMENT',
      payload: elementToDelete,
    });
  };

  return (
    <div className={'editor-container'}>
      <div className={'actions-area'}>
        <SecondaryButton
          onClick={() => {
            onSave({ config, url: src }, () => {
              window.location.href = `/player/${id}`;
            });
          }}>
          Show Preview
        </SecondaryButton>
        <PrimaryButton
          onClick={() => {
            onSave({ config, url: src }, () => {});
          }}>
          Save
        </PrimaryButton>
      </div>
      <div className={'player-area'}>
        {config && (
          <div className={'player-size'}>
            <VideoPlayer
              isEditMode={true}
              src={src}
              config={config}
              onUpdateElement={onUpdateElement}
              onDeleteElement={onDeleteElement}
              onUpdateCurrentTime={onUpdateCurrentTime}
              onUpdateTotalDuration={onUpdateTotalDuration}
            />
          </div>
        )}
        {totalDuration && <Layers layers={config.elements} duration={totalDuration} current={currentTime} onUpdate={onUpdateElement} />}
      </div>
      <div className={'control-area'}>
        <StickerPicker onSelectSticker={onAddElement} />
      </div>
    </div>
  );
};
